'use es6';

import Immutable from 'immutable';
import { cleanObject } from '../utils/formatters';
import FieldMapping from './FieldMapping';
const EMPTY_LIST = Immutable.List();
export default class DataSync extends Immutable.Record({
  data: '',
  sync: 'INBOUND',
  target: '',
  description: '',
  fieldMappings: EMPTY_LIST
}) {
  constructor(values = {}) {
    const data = Object.assign({}, values);

    if (values.fieldMappings) {
      data.fieldMappings = Immutable.List(values.fieldMappings.map(mapping => new FieldMapping(mapping)));
    }

    super(cleanObject(data));
  }

  getFieldMappingsByType(fieldType) {
    return this.fieldMappings.filter(mapping => mapping.fieldType === fieldType);
  }

  filterEmptyFieldMappings() {
    return this.set('fieldMappings', this.get('fieldMappings').filter(mapping => mapping.isValid()));
  }

  hasRequiredFields() {
    return Boolean(this.data && this.sync && this.target);
  }

}